// Published by the SupportBar (live-measured height) so fixed-positioned
// elements stacked under the header — e.g. the detail / vacation-rentals
// search pills — can offset themselves below the bar.
export const SUPPORT_BAR_HEIGHT_CSS_VAR = "--support-bar-height"
